import { forwardRef, type TextareaHTMLAttributes } from 'react';
import { cn } from './cn';
import { controlStyles } from './controlStyles';
import { useFieldControl } from './fieldContext';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** Monospace text, e.g. for pasted coordinate rows. */
  mono?: boolean;
}

/** Multi-line text field. Inside a `Field`, it is labelled automatically. */
export const Textarea = /* @__PURE__ */ forwardRef<
  HTMLTextAreaElement,
  TextareaProps
>(function Textarea({ mono = false, className, rows = 4, ...props }, ref) {
  const controlProps = useFieldControl(props);
  return (
    <textarea
      ref={ref}
      rows={rows}
      className={controlStyles({
        mono,
        className: cn('h-auto resize-y py-2 leading-relaxed', className),
      })}
      {...controlProps}
    />
  );
});
